/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as BookingRouteImport } from './routes/booking'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as GuestsIndexRouteImport } from './routes/guests.index'
import { Route as FollowUpsIndexRouteImport } from './routes/follow-ups.index'
import { Route as EpisodesIndexRouteImport } from './routes/episodes.index'
import { Route as GuestsNewRouteImport } from './routes/guests.new'
import { Route as GuestsGuestIdRouteImport } from './routes/guests.$guestId'
import { Route as EpisodesNewRouteImport } from './routes/episodes.new'
import { Route as EpisodesEpisodeIdRouteImport } from './routes/episodes.$episodeId'

const BookingRoute = BookingRouteImport.update({
  id: '/booking',
  path: '/booking',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const GuestsIndexRoute = GuestsIndexRouteImport.update({
  id: '/guests/',
  path: '/guests/',
  getParentRoute: () => rootRouteImport,
} as any)
const FollowUpsIndexRoute = FollowUpsIndexRouteImport.update({
  id: '/follow-ups/',
  path: '/follow-ups/',
  getParentRoute: () => rootRouteImport,
} as any)
const EpisodesIndexRoute = EpisodesIndexRouteImport.update({
  id: '/episodes/',
  path: '/episodes/',
  getParentRoute: () => rootRouteImport,
} as any)
const GuestsNewRoute = GuestsNewRouteImport.update({
  id: '/guests/new',
  path: '/guests/new',
  getParentRoute: () => rootRouteImport,
} as any)
const GuestsGuestIdRoute = GuestsGuestIdRouteImport.update({
  id: '/guests/$guestId',
  path: '/guests/$guestId',
  getParentRoute: () => rootRouteImport,
} as any)
const EpisodesNewRoute = EpisodesNewRouteImport.update({
  id: '/episodes/new',
  path: '/episodes/new',
  getParentRoute: () => rootRouteImport,
} as any)
const EpisodesEpisodeIdRoute = EpisodesEpisodeIdRouteImport.update({
  id: '/episodes/$episodeId',
  path: '/episodes/$episodeId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/booking': typeof BookingRoute
  '/login': typeof LoginRoute
  '/episodes/$episodeId': typeof EpisodesEpisodeIdRoute
  '/episodes/new': typeof EpisodesNewRoute
  '/guests/$guestId': typeof GuestsGuestIdRoute
  '/guests/new': typeof GuestsNewRoute
  '/episodes/': typeof EpisodesIndexRoute
  '/follow-ups/': typeof FollowUpsIndexRoute
  '/guests/': typeof GuestsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/booking': typeof BookingRoute
  '/login': typeof LoginRoute
  '/episodes/$episodeId': typeof EpisodesEpisodeIdRoute
  '/episodes/new': typeof EpisodesNewRoute
  '/guests/$guestId': typeof GuestsGuestIdRoute
  '/guests/new': typeof GuestsNewRoute
  '/episodes': typeof EpisodesIndexRoute
  '/follow-ups': typeof FollowUpsIndexRoute
  '/guests': typeof GuestsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/booking': typeof BookingRoute
  '/login': typeof LoginRoute
  '/episodes/$episodeId': typeof EpisodesEpisodeIdRoute
  '/episodes/new': typeof EpisodesNewRoute
  '/guests/$guestId': typeof GuestsGuestIdRoute
  '/guests/new': typeof GuestsNewRoute
  '/episodes/': typeof EpisodesIndexRoute
  '/follow-ups/': typeof FollowUpsIndexRoute
  '/guests/': typeof GuestsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/booking'
    | '/login'
    | '/episodes/$episodeId'
    | '/episodes/new'
    | '/guests/$guestId'
    | '/guests/new'
    | '/episodes/'
    | '/follow-ups/'
    | '/guests/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/booking'
    | '/login'
    | '/episodes/$episodeId'
    | '/episodes/new'
    | '/guests/$guestId'
    | '/guests/new'
    | '/episodes'
    | '/follow-ups'
    | '/guests'
  id:
    | '__root__'
    | '/'
    | '/booking'
    | '/login'
    | '/episodes/$episodeId'
    | '/episodes/new'
    | '/guests/$guestId'
    | '/guests/new'
    | '/episodes/'
    | '/follow-ups/'
    | '/guests/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BookingRoute: typeof BookingRoute
  LoginRoute: typeof LoginRoute
  EpisodesEpisodeIdRoute: typeof EpisodesEpisodeIdRoute
  EpisodesNewRoute: typeof EpisodesNewRoute
  GuestsGuestIdRoute: typeof GuestsGuestIdRoute
  GuestsNewRoute: typeof GuestsNewRoute
  EpisodesIndexRoute: typeof EpisodesIndexRoute
  FollowUpsIndexRoute: typeof FollowUpsIndexRoute
  GuestsIndexRoute: typeof GuestsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/booking': {
      id: '/booking'
      path: '/booking'
      fullPath: '/booking'
      preLoaderRoute: typeof BookingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guests/': {
      id: '/guests/'
      path: '/guests'
      fullPath: '/guests/'
      preLoaderRoute: typeof GuestsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/follow-ups/': {
      id: '/follow-ups/'
      path: '/follow-ups'
      fullPath: '/follow-ups/'
      preLoaderRoute: typeof FollowUpsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/episodes/': {
      id: '/episodes/'
      path: '/episodes'
      fullPath: '/episodes/'
      preLoaderRoute: typeof EpisodesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guests/new': {
      id: '/guests/new'
      path: '/guests/new'
      fullPath: '/guests/new'
      preLoaderRoute: typeof GuestsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guests/$guestId': {
      id: '/guests/$guestId'
      path: '/guests/$guestId'
      fullPath: '/guests/$guestId'
      preLoaderRoute: typeof GuestsGuestIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/episodes/new': {
      id: '/episodes/new'
      path: '/episodes/new'
      fullPath: '/episodes/new'
      preLoaderRoute: typeof EpisodesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/episodes/$episodeId': {
      id: '/episodes/$episodeId'
      path: '/episodes/$episodeId'
      fullPath: '/episodes/$episodeId'
      preLoaderRoute: typeof EpisodesEpisodeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BookingRoute: BookingRoute,
  LoginRoute: LoginRoute,
  EpisodesEpisodeIdRoute: EpisodesEpisodeIdRoute,
  EpisodesNewRoute: EpisodesNewRoute,
  GuestsGuestIdRoute: GuestsGuestIdRoute,
  GuestsNewRoute: GuestsNewRoute,
  EpisodesIndexRoute: EpisodesIndexRoute,
  FollowUpsIndexRoute: FollowUpsIndexRoute,
  GuestsIndexRoute: GuestsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
